import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxFolderViewComponent } from './folder-view.component';

// TODO - remove when routesConfig ngx STAB-1182
export const ngxFolderViewModule = angular.module('ngxFolderViewModule', [])
	.directive('ngxFolderView', downgradeComponent({ component: NgxFolderViewComponent }))
	.name;
